import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BillableStatusPicker } from '../../../../components/entity-picker/billable-status-picker/BillableStatusPicker';
import { FilterCard } from '../filter-card/FilterCard';

export type IAppointmentBillableFilterCardProps = {
  title: string;
  value: { id: boolean; name: string }[] | null;
  onChange: (value: { id: string; name: string }[]) => void;
  expanded: boolean;
  onExpandedChange: (val: boolean) => void;
};

export const AppointmentBillableFilterCard: React.FC<
  IAppointmentBillableFilterCardProps
> = (props) => {
  const { title, value, onChange, expanded, onExpandedChange } = props;

  const { t } = useTranslation();

  const mapValue = React.useCallback(
    (value: boolean) => {
      if (value) return t('APPOINTMENT.BILLABLE');
      return t('APPOINTMENT.NON_BILLABLE');
    },
    [t]
  );

  const filterValueText: string = useMemo(() => {
    if (!value || value.length === 0) return null;
    if (value.length === 1) return mapValue(value[0].id);
    return t('COMMON.CHOSEN', { count: value.length });
  }, [value, t, mapValue]);

  return (
    <FilterCard
      title={title}
      filterValue={filterValueText}
      filterValueSet={!!filterValueText}
      expanded={expanded}
      onExpandedChange={onExpandedChange}
      onValueDelete={() => {
        onChange([]);
      }}
    >
      <BillableStatusPicker
        multiple={true}
        // @ts-expect-error TECH_DEBT
        value={value}
        onChange={(newValue) => {
          onChange(newValue);
        }}
      />
    </FilterCard>
  );
};
